import React from 'react';
import styled from 'styled-components';

import mastercard from './mastercard.png';
import visa from './visa.png';

const CCVendors = (props: Props) => (
	<CCVendorWrapper className="_flex _justify-center _items-center">
		<img style={{ width: props.width ? props.width : 136 }} alt="mastercard" src={mastercard} />
		<img style={{ height: props.height ? props.height : 30 }} alt="visa" src={visa} />
	</CCVendorWrapper>
);

export default CCVendors;

interface Props {
	height?: number;
	width?: number;
}

const CCVendorWrapper = styled.div<Props>`
	display: flex;
	justify-content: center;
	align-items: center;
`;
